import React, { useState } from 'react';
import { GridList, GridListTile, Grow } from '@material-ui/core';
import withWidth, { isWidthUp } from '@material-ui/core/withWidth';
import { colors } from 'kangarootime-ui';
import Photo from './Photo';
import ArrowLeft from '../../../../assets/svg/arrowLeft';
import ArrowRight from '../../../../assets/svg/arrowRight';

const PhotoGrid = ({ photos, ...props }) => {
  const [selectedPhotoUri, setSelectedPhotoUri] = useState('');
  const [selectedPhotoUriIndex, setSelectedPhotoUriIndex] = useState(null);
  const CELL_HEIGHT = 90;

  const getGridListCols = () => {
    if (isWidthUp('md', props.width)) {
      return 6;
    }

    if (isWidthUp('sm', props.width)) {
      return 4;
    }

    return 2;
  };

  const getPhotoHeight = () => {
    if (isWidthUp('md', props.width)) {
      return 270;
    }

    return 90;
  };

  const navigateToPhoto = index => {
    setSelectedPhotoUriIndex(index);
    setSelectedPhotoUri(photos[index].image);
  };

  return (
    <div className='flex-columns' style={{ justifyContent: 'center' }}>
      <div className='flex-rows' style={{ alignItems: 'center', height: selectedPhotoUri === '' ? 0 : getPhotoHeight() }}>
        <div className='flex-columns' style={{ justifyContent: 'center', width: 24 }} onClick={() => selectedPhotoUri !== '' && selectedPhotoUriIndex !== 0 && navigateToPhoto(selectedPhotoUriIndex - 1)}>
          { selectedPhotoUri !== '' && selectedPhotoUriIndex !== 0 && <ArrowLeft fill={colors.raven} /> }
        </div>
        <div className='flex-1' style={{ height: '100%', marginBottom: 8, alignSelf: 'center' }}>
          <Grow in={selectedPhotoUri !== ''} timeout={500}>
            <img
              src={selectedPhotoUri}
              alt='selected'
              style={{ objectFit: 'contain', height: 'auto', width: '100%' }}
            />
          </Grow>
        </div>
        <div className='flex-columns' style={{ justifyContent: 'center', width: 24 }} onClick={() => selectedPhotoUri !== '' && selectedPhotoUriIndex !== photos.length - 1 && navigateToPhoto(selectedPhotoUriIndex + 1)}>
          { selectedPhotoUri !== '' && selectedPhotoUriIndex !== photos.length - 1 && <ArrowRight fill={colors.raven} /> }
        </div>
      </div>
      <GridList
        cellHeight={CELL_HEIGHT}
        cols={getGridListCols()}
        style={{ display: 'flex', flexWrap: 'wrap', overflow: 'hidden' }}
      >
        { photos.map((photo, index) => (
          <GridListTile cols={1} key={index} style={{ border: selectedPhotoUriIndex === index && '2px solid #23D3C7' }}>
            <Photo
              uri={photo.image}
              height={CELL_HEIGHT}
              onClick={() => {
                setSelectedPhotoUri(photo.image);
                setSelectedPhotoUriIndex(index);
              }}
            />
          </GridListTile>
        ))}
      </GridList>
    </div>
  );
};

export default withWidth()(PhotoGrid);
